// Models
import { IWorkoutRoutinePresentation } from 'storage/workoutRoutine/models'

// React
import { FC } from 'react'

// Misc
import { getGoalIcon } from 'utils/functions'
import { intervalDateToString } from 'utils/helpers/date'

// Components
import * as Styled from './styled'
import { Aligner, SimpleContainer, StylizedIcons } from 'heeds-ds'
import { Modal } from 'components/modals'

type Props = {
  workoutRoutine?: IWorkoutRoutinePresentation
}

const ModalRoutineInfoMobile: FC<Props> = ({ workoutRoutine }) => {
  return (
    <Modal>
      <Styled.Container data-testid="modal-routine-info-container">
        {workoutRoutine && (
          <Aligner flex="column" gap="32px">
            <Aligner>
              <StylizedIcons iconName="genericWorkout" />

              <Styled.InfoText compact={true}>
                <Styled.Title>{workoutRoutine.name}</Styled.Title>

                <Styled.SubTitle>
                  {intervalDateToString(
                    workoutRoutine.start_date,
                    workoutRoutine.end_date,
                  )}
                </Styled.SubTitle>
              </Styled.InfoText>
            </Aligner>

            <Aligner>
              <StylizedIcons iconName={getGoalIcon(workoutRoutine.goal)} />

              <Styled.InfoText compact={true}>
                <Styled.Title>{workoutRoutine.goal}</Styled.Title>

                <Styled.SubTitle>{workoutRoutine.difficulty}</Styled.SubTitle>
              </Styled.InfoText>
            </Aligner>

            {workoutRoutine.comments && (
              <SimpleContainer data-testid="modal-routine-info-comment">
                <Styled.CommentTitle>
                  Comentários sobre a Rotina
                </Styled.CommentTitle>

                <Styled.Comment>{workoutRoutine.comments}</Styled.Comment>
              </SimpleContainer>
            )}
          </Aligner>
        )}
      </Styled.Container>
    </Modal>
  )
}

export default ModalRoutineInfoMobile
